import React, {useContext} from 'react';
import {ThemeContext, logo} from 'monica-alexandria';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

const SidequestProduct = styled.div`
    padding: 2rem;
    background: ${p => p.theme.low};
    border-radius: var(--smallRadius);
    text-align: center;

    img {
        width: 15rem;
        margin-bottom: 2rem;
    }
`;

export default function Sidequest_Product() {

    const {theme} = useContext(ThemeContext);
    const {t} = useTranslation();

    return (
        <SidequestProduct>
            <img src={logo.dailyprofit[theme]} alt={t('Personalized Ads')}></img>
            <h2>{t('Personalized Ads')}</h2>
            <h5>Doitforme</h5>
        </SidequestProduct>
    );
}
